<template>
  <v-container grid-list-xs class="mt-4" style="width: auto; max-width:1070px">
    <v-row align="center" justify="center" >
      <v-col cols="12" align="center" >
        <div>
          <h1>Resultados</h1>
        </div>
      </v-col> 
    </v-row>
    <v-row justify="center" class="mx-0">
      <v-expansion-panels accordion focusable inset>
        <v-expansion-panel>
          <v-expansion-panel-header class="text-h6">Nivel A</v-expansion-panel-header>
            <v-expansion-panel-content>
              <div v-show="resultadosARegistrado" class="my-5">
                <v-row class="text-center" justify="center">
	                <object type="application/pdf" style="width:100%;height:100vh;" :data="resultadosARuta"></object>
                </v-row>
              </div>     

              <div v-show="!resultadosARegistrado" class="mt-5">
                <v-container>
                  <v-row class="text-center" justify="center">
                    <v-alert type="info" max-width="520">Aún no se han cargado los resultados de este nivel</v-alert>
                  </v-row>
                </v-container>
              </div>
            </v-expansion-panel-content>
        </v-expansion-panel>
        <v-expansion-panel>
          <v-expansion-panel-header class="text-h6">Nivel B</v-expansion-panel-header>
            <v-expansion-panel-content>
              <div v-show="resultadosBRegistrado" class="my-5">
                <v-row class="text-center" justify="center">
	                <object type="application/pdf" style="width:100%;height:100vh;" :data="resultadosBRuta"></object>
                </v-row>
              </div>     

              <div v-show="!resultadosBRegistrado" class="mt-5">
                <v-container>
                  <v-row class="text-center" justify="center">
                    <v-alert type="info" max-width="520">Aún no se han cargado los resultados de este nivel</v-alert>
                  </v-row>
                </v-container>
              </div>
            </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </v-row>
  </v-container>
</template>

<script>
import axios from 'axios';
import { documentosBaseURL, createForm }  from '@/general';


export default {
  metaInfo: {
    title: 'Olimpiada de Quimica',
    titleTemplate: 'Resultados - %s',
    htmlAttrs: {
      lang: 'es',
      amp: true
    }
  },
  data () {
    return {
      resultadosARegistrado: false,
      resultadosBRegistrado: false,
      resultadosARuta: null,
      resultadosBRuta: null,
    }
  },

  created(){
    this.getResultadosA()
    this.getResultadosB()
  },

  methods:{
    async getResultadosA() {  
      let response = await this.resultados(createForm({nivel: 'A'}));
      if(response.state == '1'){
        delete response['state']
        if(Object.keys(response).length === 0){
          this.resultadosARegistrado = false
        }else{
          this.resultadosARegistrado = true
          this.resultadosARuta = documentosBaseURL + response.ruta
        }
      } // que hacer en caso de otros estados?

    },

    async getResultadosB() {  
      let response = await this.resultados(createForm({nivel: 'B'}));
      if(response.state == '1'){
        delete response['state']
        if(Object.keys(response).length === 0){
          this.resultadosBRegistrado = false
        }else{
          this.resultadosBRegistrado = true
          this.resultadosBRuta = documentosBaseURL + response.ruta
        }
      } // que hacer en caso de otros estados?

    },

    resultados(data){
      return new Promise((resolve, reject) => {
        axios.post('resultados.php', data)
        .then((response) => {
            resolve(response.data);
        }).catch((error) => reject(error));
      });
    },
  }
}
</script>
